export const GET_STYLING_USERS_SUCCESS = 'GET_STYLING_USERS_SUCCESS';
export const GET_STYLING_USER_SUCCESS = 'GET_STYLING_USER_SUCCESS';
export const SAVE_STYLING_USER_SUCCESS = 'SAVE_STYLING_USER_SUCCESS';
export const STYLING_USER_LOAD_METADATA_SUCCESS = 'STYLING_USER_LOAD_METADATA_SUCCESS';
export const REMOVED_STYLING_USER_SUCCESS = 'REMOVED_STYLING_USER_SUCCESS';
